<template>
  <span v-if="isFacebookAudience">
    {{ facebookAudienceSize.lower }}
    -
    {{ facebookAudienceSize.upper }}
  </span>
  <span v-else-if="isSavedQuery">
    {{ saveQuerySize }}
  </span>
  <span v-else-if="isGaUserList">
    <p>display: {{ gaUserListSize.display }}</p>
    <p>search: {{ gaUserListSize.search }}</p>
  </span>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFacebookAudience() {
      return ['facebook_custom_audiences', 'facebook_saved_audiences'].indexOf(this.type) >= 0;
    },
    isSavedQuery() {
      return this.type === 'saved_queries';
    },
    isGaUserList() {
      return this.type === 'ga_user_list';
    },
    facebookAudienceSize() {
      if (!this.isFacebookAudience) {
        return null;
      }

      return {
        lower: Numbro(this.source?.approximate_count_lower_bound || 0).format({
          thousandSeparated: true,
        }),
        upper: Numbro(this.source?.approximate_count_upper_bound || 0).format({
          thousandSeparated: true,
        }),
      };
    },
    saveQuerySize() {
      if (!this.isSavedQuery) {
        return null;
      }

      return Numbro(this.source?.count || 0).format({ thousandSeparated: true });
    },
    gaUserListSize() {
      if (!this.isGaUserList) {
        return null;
      }

      return {
        display: this.source?.size_range_for_display_description || 'N/A',
        search: this.source?.size_range_for_search_description || 'N/A',
      };
    },
  },
};
</script>
